import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslateModule} from '@ngx-translate/core';
import {SecurityModule} from '@app/security';
import {ImageCropperComponent} from 'ngx-image-cropper';
import {LangPickerComponent} from '../shared/lang-picker/lang-picker.component';
import {GroinLogoComponent} from '../shared/groin-logo/groin-logo.component';
import {UserAvatarComponent} from '../shared/user-avatar/user-avatar.component';
import {PrimeUiModule} from './prime/prime-ui.module';

import {AppMenuComponent} from './components/app-menu/app-menu.component';
import {AppMobileTabBarComponent} from './components/app-mobile-tab-bar/app-mobile-tab-bar.component';
import {AppSidebarComponent} from './components/app-sidebar/app-sidebar.component';
import {FooterComponent, HeaderComponent, SearchInputComponent} from './components';
import {SeasonAtmosphereComponent} from './components/season-atmosphere/season-atmosphere.component';
import {SeasonMarkComponent} from './components/season-mark/season-mark.component';
import {OneColumnLayoutComponent, ThreeColumnsLayoutComponent, TwoColumnsLayoutComponent} from './layouts';
import {PipesModule} from './pipes/pipes.module';
import {RestaurantChangedDialogComponent} from '../@core/utils/restaurant-changed-dialog.component';
import {AppThemeService} from './prime/app-theme.service';

const COMPONENTS = [
	AppMenuComponent,
	AppMobileTabBarComponent,
	AppSidebarComponent,
	HeaderComponent,
	SeasonAtmosphereComponent,
	SeasonMarkComponent,
	FooterComponent,
	SearchInputComponent,
	OneColumnLayoutComponent,
	ThreeColumnsLayoutComponent,
	TwoColumnsLayoutComponent,
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		PipesModule,
		PrimeUiModule,
		SecurityModule,
		ImageCropperComponent,
		TranslateModule,
		LangPickerComponent,
		GroinLogoComponent,
		UserAvatarComponent,
		FontAwesomeModule,
	],
	exports: [CommonModule, FormsModule, PipesModule, PrimeUiModule, SecurityModule, GroinLogoComponent, UserAvatarComponent, ...COMPONENTS],
	declarations: [...COMPONENTS, RestaurantChangedDialogComponent],
})
export class ThemeModule {
	static forRoot(): ModuleWithProviders<ThemeModule> {
		return {
			ngModule: ThemeModule,
			providers: [AppThemeService],
		};
	}
}
